import React from 'react';
import gateBg from '../assets/images/gate_bg.jpg';

const IntroSection = () => {
  return (
    <section
      className="relative text-white py-24"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 102, 204, 0.0), rgba(27, 41, 81, 0.0)), url(${gateBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Shinsegae VPN (Warp)
          </h1>
          <h2 className="text-2xl md:text-3xl font-medium mb-8">
            원격근무 시스템 접속 안내
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            신세계 그룹 임직원의 안전하고 편리한 원격근무를 위한
            Cloudflare WARP VPN 설치 및 접속 방법을 안내해드립니다.
          </p>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
